export default "__VITE_ASSET__BonT5suN__"